import * as VueTypedi from 'vue-typedi';
import httpServiceModule from '@/HostApp/services/HttpService/HttpServiceModule';

export const CLIENT = new VueTypedi.Token('http-client');
export const setTransportService = (
	restClient: TRA.IBaseTransportService,
	baseApiUrl: string = '',
	_VueTypedi = VueTypedi
): void => {
	class TransportService implements TRA.IBaseTransportService {
		protected defaultHeaders: TRA.IRequestHeaders = {
			'Content-Type': 'application/json'
		};
		protected baseUrl: Common.StrNull = null;
		protected client!: TRA.IBaseTransportService;
		public baseApiUrl!: string;

		constructor() {
			this.client = restClient;
			this.client.baseApiUrl = baseApiUrl;
			this.baseApiUrl = baseApiUrl;
		}

		public setBaseUrl(baseUrl: string): void {
			this.baseUrl = baseUrl;
		}

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		private getResponse<TResponse>(response: any): TRA.IResponse<TResponse> {
			const { data, request, config, status, isError = false } = response;

			return { data, request, config, status, isError };
		}

		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		private getConfig(config = {} as TRA.IRequestConfig): TRA.IRequestConfig {
			const { headers = {} } = config;

			if (this.baseUrl) {
				config.baseURL = this.baseUrl;
			}

			return { ...config, headers: { ...this.defaultHeaders, ...headers } };
		}

		public async get<TResponse = TRA.CommonResponse>(
			url: string,
			config?: TRA.IRequestConfig
		): Promise<TRA.IResponse<TResponse>> {
			const response = await this.client.get(url, this.getConfig(config));

			return this.getResponse<TResponse>(response);
		}

		public async delete<TResponse = TRA.CommonResponse, TData = TResponse>(
			url: string,
			data?: TData,
			config?: TRA.IRequestConfig
		): Promise<TRA.IResponse<TResponse>> {
			const response = await this.client.delete(url, data, this.getConfig(config));

			return this.getResponse<TResponse>(response);
		}

		public async head<TResponse = TRA.CommonResponse>(
			url: string,
			config?: TRA.IRequestConfig
		): Promise<TRA.IResponse<TResponse>> {
			const response = await this.client.head(url, this.getConfig(config));

			return this.getResponse<TResponse>(response);
		}

		public async post<TResponse = TRA.CommonResponse, TData = TResponse>(
			url: string,
			data?: TData,
			config?: TRA.IRequestConfig
		): Promise<TRA.IResponse<TResponse>> {
			const response = await this.client.post(url, data, this.getConfig(config));

			return this.getResponse<TResponse>(response);
		}

		public async put<TResponse = TRA.CommonResponse, TData = TResponse>(
			url: string,
			data?: TData,
			config?: TRA.IRequestConfig
		): Promise<TRA.IResponse<TResponse>> {
			const response = await this.client.put(url, data, this.getConfig(config));

			return this.getResponse<TResponse>(response);
		}

		public async patch<TResponse = TRA.CommonResponse, TData = TResponse>(
			url: string,
			data?: TData,
			config?: TRA.IRequestConfig
		): Promise<TRA.IResponse<TResponse>> {
			const response = await this.client.patch(url, data, this.getConfig(config));

			return this.getResponse<TResponse>(response);
		}
	}
	const transportService = new TransportService();

	_VueTypedi.Container.set(CLIENT, transportService);
};

/* eslint-disable @typescript-eslint/no-explicit-any, no-console*/
const getStub = (name: string, isTest: boolean, ...args: any[]): Promise<any> =>
	Promise.resolve()
		.then(() => console[isTest ? 'warn' : 'trace'](`${name} request:`, ...args))
		.then(() => ({ data: {} }));

export const getTransportService = (isTest: boolean = false): TRA.IBaseTransportService => ({
	get: (...args: any[]): Promise<any> => getStub('Get', isTest, ...args),
	delete: (...args: any[]): Promise<any> => getStub('Delete', isTest, ...args),
	head: (...args: any[]): Promise<any> => getStub('Head', isTest, ...args),
	post: (...args: any[]): Promise<any> => getStub('Post', isTest, ...args),
	put: (...args: any[]): Promise<any> => getStub('Put', isTest, ...args),
	patch: (...args: any[]): Promise<any> => getStub('Patch', isTest, ...args),
	baseApiUrl: ''
});
/* eslint-enable @typescript-eslint/no-explicit-any, no-console */

export const mockTransportService = (_VueTypedi: typeof VueTypedi, transport?: TRA.IBaseTransportService): void => {
	setTransportService({ ...(transport ? httpServiceModule : getTransportService(true)) }, '', _VueTypedi);
};

export const setTransport = (
	baseApiUrl: Host.IInitFWOptions['baseApiUrl'],
	isTest: Host.IInitFWOptions['isTest'],
	transport?: Host.IInitFWOptions['transport']
): void => {
	setTransportService(isTest || !transport ? getTransportService(isTest) : httpServiceModule, baseApiUrl);
};
